let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dovy2")).then(() => parcelRequire('9WKzB'));